var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgScheduleReview = function SvgScheduleReview(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5071 31.1408C29.1552 31.1408 32.1127 28.1834 32.1127 24.5352C32.1127 20.887 29.1552 17.9296 25.5071 17.9296C21.8589 17.9296 18.9014 20.887 18.9014 24.5352C18.9014 28.1834 21.8589 31.1408 25.5071 31.1408ZM25.5071 33.0282C30.1976 33.0282 34 29.2257 34 24.5352C34 19.8447 30.1976 16.0422 25.5071 16.0422C20.8165 16.0422 17.0141 19.8447 17.0141 24.5352C17.0141 29.2257 20.8165 33.0282 25.5071 33.0282Z",
    fill: "#0258FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.507 19.8169C26.0282 19.8169 26.4507 20.1338 26.4507 20.5246V24.7711C26.4507 25.162 26.0282 25.4789 25.507 25.4789C24.9859 25.4789 24.5634 25.162 24.5634 24.7711V20.5246C24.5634 20.1338 24.9859 19.8169 25.507 19.8169Z",
    fill: "#0258FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7324 24.5352C21.7324 24.014 22.0574 23.5916 22.4583 23.5916H25.7248C26.1257 23.5916 26.4507 24.014 26.4507 24.5352C26.4507 25.0564 26.1257 25.4789 25.7248 25.4789H22.4583C22.0574 25.4789 21.7324 25.0564 21.7324 24.5352Z",
    fill: "#0258FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70071 0.471802C10.4825 0.471802 11.1162 1.10554 11.1162 1.88729V7.54927C11.1162 8.33102 10.4825 8.96476 9.70071 8.96476C8.91895 8.96476 8.28522 8.33102 8.28522 7.54927V1.88729C8.28522 1.10554 8.91895 0.471802 9.70071 0.471802Z",
    fill: "#7EAAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4402 0.471802C23.2219 0.471802 23.8556 1.10554 23.8556 1.88729V7.54927C23.8556 8.33102 23.2219 8.96476 22.4402 8.96476C21.6584 8.96476 21.0247 8.33102 21.0247 7.54927V1.88729C21.0247 1.10554 21.6584 0.471802 22.4402 0.471802Z",
    fill: "#7EAAFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03873 3.30273C2.08435 3.30273 0.5 4.88708 0.5 6.84147V28.0739C0.5 30.0282 2.08434 31.6126 4.03873 31.6126H14.6549C15.4367 31.6126 16.0704 30.9789 16.0704 30.1971V30.1971C16.0704 29.4153 15.4367 28.7816 14.6549 28.7816H4.03873C3.64785 28.7816 3.33099 28.4647 3.33099 28.0739V6.84147C3.33099 6.45059 3.64785 6.13372 4.03873 6.13372H28.1021C28.493 6.13372 28.8099 6.45059 28.8099 6.84147V13.683C28.8099 14.4648 29.4436 15.0985 30.2254 15.0985V15.0985C31.0071 15.0985 31.6408 14.4648 31.6408 13.683V6.84147C31.6408 4.88708 30.0565 3.30273 28.1021 3.30273H4.03873Z",
    fill: "#7EAAFF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScheduleReview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/schedule-review.c78a66ce.svg";
export { ForwardRef as ReactComponent };